import Vue from 'vue';

export const ERROR_EVENT = 'error'
export const FATAL_ERROR_EVENT = 'errorPage'
export const NOT_FOUND_ERROR_EVENT = 'error404'

export const ErrorBus = new Vue();